import React, { useState, useEffect } from "react";
import { Phone, Mail, Facebook, Instagram, Youtube, Menu, X, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList, navigationMenuTriggerStyle } from "@/components/ui/navigation-menu";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
function DesktopMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="56486" className="flex gap-4">
        {[1, 2, 3, 4].map(i => <div key={i} className="h-4 w-20 bg-muted animate-pulse rounded-[3px]" data-index={i} />)}
      </div>;
  }
  return <NavigationMenu>
      <NavigationMenuList className="gap-8">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className={cn(navigationMenuTriggerStyle(), "bg-transparent text-[14px] font-sans font-medium uppercase tracking-[0.05em] text-primary hover:bg-primary hover:text-white focus:bg-primary focus:text-white transition-all duration-300 rounded-[3px] px-4 py-2")}>
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
function MobileMenuConsumer({
  onClose
}: {
  onClose: () => void;
}) {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-4 p-4">
        {[1, 2, 3, 4].map(i => <div key={i} className="h-8 w-full bg-muted animate-pulse rounded-[3px]" data-index={i} />)}
      </div>;
  }
  return <nav className="flex flex-col gap-2 p-6">
      {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} className="text-[14px] font-sans font-medium uppercase tracking-[0.05em] text-primary py-3 border-b border-border hover:bg-primary/5 transition-colors" onClick={onClose} data-index={i}>
          {item.label}
        </Link>)}
    </nav>;
}
export default function ToppmenyOchKontakt() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
            setIsMobileMenuOpen(false);
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  const phone = "08-123 45 67";
  const email = "kontakt@robotaxi.nu";
  const address = "Robotaxi Sverige, Stockholm";
  return <section id="header" className="bg-background text-foreground font-sans">
      {}
      <div className="bg-primary text-white py-2 px-4 md:px-8">
        <div className="container mx-auto flex flex-col md:flex-row justify-between items-center gap-2 text-xs md:text-[13px] font-sans font-medium tracking-wide">
          <div className="flex flex-wrap justify-center md:justify-start gap-4 md:gap-6">
            {phone && <Link to={`tel:${phone}`} className="flex items-center gap-2 hover:text-white/80 transition-colors">
                <Phone className="size-3.5" />
                
              </Link>}
            {email && <Link to={`mailto:${email}`} className="flex items-center gap-2 hover:text-white/80 transition-colors">
                <Mail className="size-3.5" />
                <span>{email}</span>
              </Link>}
            {address && <div className="hidden lg:flex items-center gap-2 opacity-90">
                <MapPin className="size-3.5" />
                <span>{address}</span>
              </div>}
          </div>
          
          <div className="flex items-center gap-4">
            <Link to="#" aria-label="Facebook" className="hover:text-white/80 transition-colors">
              <Facebook className="size-4" />
            </Link>
            <Link to="#" aria-label="Instagram" className="hover:text-white/80 transition-colors">
              <Instagram className="size-4" />
            </Link>
            <Link to="#" aria-label="YouTube" className="hover:text-white/80 transition-colors">
              <Youtube className="size-4" />
            </Link>
          </div>
        </div>
      </div>

      {}
      <header className={cn("sticky top-0 z-50 w-full border-b border-transparent transition-all duration-300", isScrolled ? "bg-background/80 backdrop-blur-md border-border shadow-sm py-2" : "bg-background py-4")}>
        <div className="container mx-auto px-4 md:px-8 flex items-center justify-between">
          {}
          <div className="flex items-center gap-4">
            <Link to="/HomePage" className="flex-shrink-0 block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592905/img/tss_logo.png" alt="Robotaxi Sverige Logo" className="h-10 md:h-12 w-auto object-contain" />
            </Link>
            
            {}
            <Badge variant="secondary" className="hidden sm:flex bg-primary text-white hover:bg-primary/90 border-none shadow-sm px-3 py-1 rounded-[3px] text-[10px] uppercase tracking-wider font-bold">
              Framtiden
            </Badge>
          </div>

          {}
          <div className="hidden lg:block">
            <MenuProvider menu_id="16">
              <DesktopMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="lg:hidden">
            <Button variant="ghost" size="icon" onClick={() => setIsMobileMenuOpen(true)} className="text-foreground hover:bg-muted">
              <Menu className="size-6" />
              <span className="sr-only">Öppna meny</span>
            </Button>
          </div>
        </div>
      </header>

      {}
      {isMobileMenuOpen && <div className="fixed inset-0 z-[60] bg-background/95 backdrop-blur-sm lg:hidden animate-in fade-in duration-200">
          <div className="flex flex-col h-full">
            <div className="flex items-center justify-between p-4 border-b border-border">
              <div className="flex items-center gap-3">
                 <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592905/img/tss_logo.png" alt="Robotaxi Logo" className="h-8 w-auto" />
                <span className="font-serif font-bold text-primary text-sm uppercase tracking-wider">Robotaxi</span>
              </div>
              <Button variant="ghost" size="icon" onClick={() => setIsMobileMenuOpen(false)} className="text-foreground">
                <X className="size-6" />
                <span className="sr-only">Stäng meny</span>
              </Button>
            </div>
            
            <div className="flex-1 overflow-y-auto">
              <MenuProvider menu_id="16">
                <MobileMenuConsumer onClose={() => setIsMobileMenuOpen(false)} />
              </MenuProvider>
              
              <div className="p-6 mt-4 border-t border-border bg-secondary">
                <h3 className="text-[12px] font-sans font-bold text-muted-foreground uppercase tracking-widest mb-4">Kontakt</h3>
                <div className="space-y-3 text-[14px] font-sans text-foreground">
                  <div className="flex items-center gap-3">
                    <Phone className="size-4 text-primary" />
                    <Link to={`tel:${phone}`}>{phone}</Link>
                  </div>
                  <div className="flex items-center gap-3">
                    <Mail className="size-4 text-primary" />
                    <Link to={`mailto:${email}`}>{email}</Link>
                  </div>
                  <div className="flex items-start gap-3">
                    <MapPin className="size-4 text-primary mt-0.5" />
                    <span>{address}</span>
                  </div>
                </div>
                
                <div className="flex gap-4 mt-6">
                  <Link to="#" className="bg-background p-2 rounded-[3px] shadow-sm text-foreground hover:text-primary transition-colors border border-border">
                    <Facebook className="size-5" />
                  </Link>
                  <Link to="#" className="bg-background p-2 rounded-[3px] shadow-sm text-foreground hover:text-primary transition-colors border border-border">
                    <Instagram className="size-5" />
                  </Link>
                  <Link to="#" className="bg-background p-2 rounded-[3px] shadow-sm text-foreground hover:text-primary transition-colors border border-border">
                    <Youtube className="size-5" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>}
    </section>;
}